// extracted by mini-css-extract-plugin
export var container = "_cf-0";
export var icon = "_cf-1";
export var text = "_cf-2";